import { useEffect, useState } from "react";

import { cn } from "@/lib/utils";

const FMT_ABS = new Intl.DateTimeFormat(undefined, {
  weekday: "short",
  month: "short",
  day: "numeric",
  hour: "numeric",
  minute: "2-digit",
});

const FMT_REL = new Intl.RelativeTimeFormat(undefined, { numeric: "auto" });

function relative(target: Date, now: Date): string {
  const diffMs = target.getTime() - now.getTime();
  const absMin = Math.round(Math.abs(diffMs) / 60_000);
  const sign = diffMs < 0 ? -1 : 1;
  if (absMin < 60) return FMT_REL.format(sign * absMin, "minute");
  const absHr = Math.round(absMin / 60);
  if (absHr < 36) return FMT_REL.format(sign * absHr, "hour");
  const absDay = Math.round(absHr / 24);
  return FMT_REL.format(sign * absDay, "day");
}

export function DeadlineCell({
  iso,
  overdue,
  expanded = false,
}: {
  iso: string;
  overdue: boolean;
  expanded?: boolean;
}) {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const i = setInterval(() => setNow(new Date()), 60_000);
    return () => clearInterval(i);
  }, []);

  const target = new Date(iso);
  const rel = relative(target, now);
  const abs = FMT_ABS.format(target);

  return (
    <span
      title={abs}
      className={cn(
        "inline-flex flex-col gap-0.5 text-xs leading-tight",
        overdue ? "text-destructive" : "text-foreground",
      )}
    >
      <span className="font-medium">{rel}</span>
      {expanded ? <span className="text-[11px] text-muted-foreground">{abs}</span> : null}
    </span>
  );
}
